import { StatusBar } from "expo-status-bar";
import React from "react";
import ENV from "app/utils/ENV";
import PropTypes from "prop-types";
import {
  StyleSheet,
  View,
  ScrollView,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  TextInput,
  Dimensions,
  Vibration,
} from "react-native";
import TouchableOpacity from "app/components/TouchableOpacity";
import Text from "app/components/Text";
import Value from "app/components/Value";
import Icon from "app/components/Icon";
// import Canvas from 'app/components/Canvas'
import apiActions from "app/utils/apiActions";
import storageActions from "app/utils/storageActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import iconHelpers from "app/utils/iconHelpers";
import { styleSheet, colors, sizes } from "app/utils/styleSheet";
import haptics from "app/utils/haptics";

import Badge from "app/components/chapter/Badge";
import Tag from "app/components/chapter/Tag";

import {
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  AntDesign,
  FontAwesome5,
  Fontisto,
  Entypo,
  Octicons,
  Foundation,
  FontAwesome,
} from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

export default class IconTest extends React.Component {
  static contextType = StyleContext;

  constructor(props) {
    super(props);
    this.state = {
      fonts: [],
      icon: null,
      color: null,
    };
  }

  async componentDidMount() {
    let fontPacks = [
      Ionicons,
      MaterialCommunityIcons,
      MaterialIcons,
      AntDesign,
      FontAwesome5,
      Fontisto,
      Entypo,
      Octicons,
      Foundation,
      FontAwesome,
    ];

    let fonts = fontPacks.map((fp) => {
      let Icon = fp;
      // console.log(Icon.glyphMap)
      // console.log(<Icon/>)
      let glyphs = Icon.glyphMap;
      if (!glyphs) glyphs = Icon.getRawGlyphMap();
      let family = Icon.getFontFamily();
      if (!family) console.log("missing font-family:", <Icon />);
      if (!!Icon && !!glyphs && !!family) {
        return {
          Icon,
          glyphs,
          family,
          expanded: false,
        };
      }
    });
    fonts = fonts.filter((f) => !!f);
    this.setState({ fonts });
  }

  render() {
    let { navigation } = this.props;
    let { fonts, icon, color } = this.state;
    // let displayColor = valueHelpers.getColor({ color });
    let displayColor = valueHelpers.colorAsHex(color, this.context.colorScheme);

    return (
      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={this.styles().container}
      >
        {this.renderHaptics()}

        <Text>color scheme: {this.context.colorScheme}</Text>

        <View style={this.styles().row}>
          <View style={this.styles().selectorRow}>
            {iconHelpers.iconOptions(true).map((icn, i) =>
              icn == "hidden_icons" ? (
                <Text key={i}>Icons for internal use: </Text>
              ) : (
                <TouchableOpacity
                  key={i}
                  style={[this.styles().selectable]}
                  onPress={() => this.setState({ icon: icn })}
                >
                  <Icon name={icn} color={this.context.colors.foreground} />
                </TouchableOpacity>
              ),
            )}
          </View>

          <View>
            {!!icon && (
              <div>
                <pre
                  style={{
                    color: displayColor,
                  }}
                >
                  {JSON.stringify(icon, null, 2)}
                </pre>
              </div>
            )}
            {!!color && (
              <div>
                <pre style={{ color: displayColor }}>
                  {JSON.stringify(color, null, 2)}
                </pre>
                <pre
                  style={{
                    color: displayColor,
                    textDecorationLine: "line-through",
                    opacity: 0.6,
                  }}
                >
                  {JSON.stringify(color, null, 2)}
                </pre>
                <pre
                  style={{
                    color: displayColor,
                    backgroundColor: this.context.colors.fill,
                  }}
                >
                  {JSON.stringify(color, null, 2)}
                </pre>
              </div>
            )}

            <View style={{ flexDirection: "row" }}>
              <Tag
                icon
                value={{ id: 99999999, icon, color, text: "Value name" }}
              />
              <Tag
                icon
                highlighted
                value={{ id: 99999999, icon, color, text: "Value name" }}
              />
            </View>

            <Value
              value={{
                id: 99999999,
                icon,
                color,
                progress_at: [
                  new Date(0),
                  new Date(0),
                  new Date(0),
                  new Date(0),
                  new Date(0),
                ],
                text: "Value name",
              }}
            />
            <View style={{ flexDirection: "row", marginTop: 50 }}>
              <Badge
                chapter={{}}
                noTooltip
                moment={{ value: { color, icon } }}
                large
                scale={2}
                style={{ marginRight: 15 }}
              />
              <Badge
                chapter={{}}
                noTooltip
                moment={{
                  completed_at: new Date(),
                  value: {
                    id: 9999,
                    color,
                    icon,
                    progress_at: [new Date(), new Date(), new Date()],
                  },
                }}
                large
                scale={2}
                style={{ marginRight: 15 }}
              />
              <Badge
                chapter={{}}
                noTooltip
                moment={{ value: { color, icon, is_progress: true } }}
                large
                scale={2}
                style={{ marginRight: 15 }}
              />
              <Badge
                chapter={{}}
                noTooltip
                moment={{ value: { color, icon, completed_at: new Date() } }}
                large
                scale={2}
                style={{ marginRight: 15 }}
              />
            </View>
            <View style={{ flexDirection: "row", marginTop: 10 }}>
              <Badge
                chapter={{}}
                noTooltip
                moment={{ value: { color, icon } }}
                style={{ marginRight: 15 }}
              />
              <Badge
                chapter={{}}
                noTooltip
                moment={{
                  completed_at: new Date(),
                  value: {
                    id: 9999,
                    color,
                    icon,
                    progress_at: [new Date(), new Date(), new Date()],
                  },
                }}
                style={{ marginRight: 15 }}
              />
              <Badge
                chapter={{}}
                noTooltip
                moment={{ value: { color, icon, is_progress: true } }}
                style={{ marginRight: 15 }}
              />
              <Badge
                chapter={{}}
                noTooltip
                moment={{ value: { color, icon, completed_at: new Date() } }}
                style={{ marginRight: 15 }}
              />
            </View>
          </View>

          <View style={this.styles().selectorRow}>
            {valueHelpers.colorOptions().map((c, i) => {
              let hex = valueHelpers.colorAsHex(c, this.context.colorScheme);
              return (
                <TouchableOpacity
                  key={i}
                  style={[
                    this.styles().selectable,
                    this.styles().largerSelectable,
                  ]}
                  onPress={() => this.setState({ color: c })}
                >
                  <View
                    style={[
                      this.styles().colorDot,
                      {
                        backgroundColor: hex,
                      },
                    ]}
                  />
                  <Text>{c}</Text>
                  <Text>
                    {valueHelpers.colorAsHex(c, this.context.colorScheme)}
                  </Text>
                  <Text>
                    {Math.round(colorHelpers.hexAsFloat(hex) * 100) / 100}
                  </Text>
                </TouchableOpacity>
              );
            })}
          </View>
        </View>

        {fonts.map((font, i) => {
          return (
            <View key={i}>
              <Text
                style={{ paddingTop: this.context.sizes.base }}
                onPress={() => {
                  this.setState({
                    fonts: fonts.map((f) =>
                      f.family == font.family
                        ? { ...font, expanded: !font.expanded }
                        : f,
                    ),
                  });
                }}
              >
                {font.family.toUpperCase()} {font.expanded ? "(^)" : "(v)"}
              </Text>
              {font.expanded &&
                Object.keys(font.glyphs).map((key, j) => {
                  return (
                    <View key={j} style={this.styles().row}>
                      <Text>{font.family}</Text>
                      <Text>{key}</Text>
                      <Text>{font.glyphs[key].toString(16)}</Text>
                      {/*<Text>{String.fromCodePoint(parseInt(f.glyphs[key], 16))}</Text>*/}
                      <Text>
                        <font.Icon name={key} size={30} />
                      </Text>
                    </View>
                  );
                })}
            </View>
          );
        })}

        <Text
          style={{ paddingTop: this.context.sizes.base }}
          onPress={() => {
            this.setState({
              allFontsExpanded: !this.state.allFontsExpanded,
            });
          }}
        >
          ALL ICONS {this.state.allFontsExpanded ? "(^)" : "(v)"}
        </Text>
        {this.state.allFontsExpanded && (
          <View style={[this.styles().row, { flex: 1, flexWrap: "wrap" }]}>
            {fonts.map((font, i) => {
              return Object.keys(font.glyphs).map((key, j) => {
                return (
                  <TouchableOpacity
                    key={j}
                    onPress={() => {
                      console.log(
                        `${font.family}, ${key}, ${font.glyphs[key].toString(
                          16,
                        )}`,
                      );
                    }}
                  >
                    <Text style={{ padding: 10 }}>
                      <font.Icon name={key} size={30} />
                    </Text>
                  </TouchableOpacity>
                );
              });
            })}
          </View>
        )}
      </ScrollView>
    );
  }

  renderHaptics = () => {
    // if (ENV.WEB) return null;
    return (
      <View>
        <Text>Vibration</Text>
        <View style={{ flexDirection: "row" }}>
          <Text button onPress={() => Vibration.vibrate(800)}>
            800
          </Text>
          <Text button onPress={() => Vibration.vibrate(400)}>
            400
          </Text>
          <Text button onPress={() => Vibration.vibrate(100)}>
            100
          </Text>
          <Text button onPress={() => Vibration.vibrate(0)}>
            0
          </Text>
          <Text button onPress={() => Vibration.vibrate([400], true)}>
            Repeat
          </Text>
          <Text button onPress={() => Vibration.cancel()}>
            Stop
          </Text>
        </View>
        <Text>Haptics Feedback</Text>
        <View style={{ flexDirection: "row" }}>
          <Text button onPress={haptics.success}>
            Success
          </Text>
          <Text button onPress={haptics.error}>
            Error
          </Text>
          <Text button onPress={haptics.warning}>
            Warning
          </Text>
        </View>
        <Text>Haptics Impact</Text>
        <View style={{ flexDirection: "row" }}>
          <Text button onPress={haptics.light}>
            Light
          </Text>
          <Text button onPress={haptics.medium}>
            Medium
          </Text>
          <Text button onPress={haptics.heavy}>
            Heavy
          </Text>
        </View>
      </View>
    );
  };

  styles = () => ({
    container: {
      flex: 1,
      flexDirection: "column",
      // justifyContent: "space-around",
      padding: this.context.sizes.base,
    },
    row: {
      flexDirection: "row",
      borderWidth: 1,
      borderColor: this.context.colors.trim,
      justifyContent: "space-between",
    },
    selectorRow: {
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "center",
      borderWidth: 1,
      borderColor: this.context.colors.trim,
      borderRadius: this.context.sizes.small,
      maxWidth:
        (this.context.sizes.itemHeight + this.context.sizes.small * 4) * 10 + 3,
    },
    selectable: {
      width: this.context.sizes.itemHeight + this.context.sizes.small * 2,
      height: this.context.sizes.itemHeight + this.context.sizes.small * 2,
      justifyContent: "center",
      alignItems: "center",
      // backgroundColor: this.context.colors.fill,
      borderColor: this.context.colors.fill,
      borderWidth: 1,
      borderRadius: this.context.sizes.small,
      margin: this.context.sizes.small,
      padding: this.context.sizes.small,
    },
    largerSelectable: {
      width: this.context.sizes.itemHeight * 2 + this.context.sizes.base * 2,
      height: this.context.sizes.itemHeight * 2 + this.context.sizes.base * 2,
      margin: this.context.sizes.base,
      padding: this.context.sizes.base,
    },
    colorDot: {
      width: this.context.sizes.itemHeight * 2,
      height: this.context.sizes.itemHeight * 2,
      borderRadius: this.context.sizes.itemHeight / 1,
    },
  });
}
